export default {
  noResults: 'No results'
};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/newton/wp-content/themes/newton/node_modules/instantsearch.js/es/widgets/refinement-list/defaultTemplates.searchForFacetValue.js
// module id = 666
// module chunks = 0